import { IIndicator, UIErrorHandlingService } from "@gtmhub/error-handling";
import { ISelection } from "@gtmhub/configuration/workday/models";
import { WorkdayUserProvisioningService } from "@gtmhub/configuration/workday/workday-user-provisioning-service";
import { StateService } from "@uirouter/angularjs";
import { IComponentOptions, IQService, IRootScopeService } from "angular";

export class WizardSelectionsCtrl {
  indicators: {
    loading?: IIndicator;
    saving?: boolean;
  };

  selections: ISelection[];
  static $inject = ["$rootScope", "WorkdayUserProvisioningService", "UIErrorHandlingService", "$state", "$q"];

  constructor(
    private $rootScope: IRootScopeService,
    private workdayUserProvisioningService: WorkdayUserProvisioningService,
    private uiErrorHandlingService: UIErrorHandlingService,
    private $state: StateService,
    private $q: IQService
  ) {}

  $onInit(): void {
    this.indicators = {};

    this.getSelections();
    this.$rootScope.$on("selectionsUpdated", () => this.updateSelections());
  }

  goToSelection(selectionId: string): void {
    this.$state.go(".advanced-criteria", { selectionId: selectionId });
  }

  updateSelections(): void {
    this.workdayUserProvisioningService
      .getAccountSelections()
      .then((response) => {
        this.selections = response;
        this.unApproveMappingAndRemoveUnfinishedMappingId();
      })
      .catch((error) => {
        this.indicators.saving = false;
        this.uiErrorHandlingService.handleModal(error);
      });
  }

  resetIndicator(indicator: keyof WizardSelectionsCtrl["indicators"]): void {
    delete this.indicators[indicator];
  }

  getSelections(): void {
    this.indicators.loading = { progress: true };
    this.workdayUserProvisioningService
      .getAccountSelections()
      .then((response) => {
        this.selections = response;
        delete this.indicators.loading;
      })
      .catch((error) => {
        delete this.indicators.loading;
        this.uiErrorHandlingService.handleModal(error);
      });
  }

  copySelection(selection: ISelection): void {
    if (!this.indicators.saving) {
      this.indicators.saving = true;
      this.workdayUserProvisioningService
        .postSelection(selection)
        .then(() => {
          this.updateSelections();
        })
        .catch((error) => {
          this.indicators.saving = false;
          this.uiErrorHandlingService.handleModal(error);
        });
    }
  }

  deleteSelection(selectionId: string): void {
    if (!this.indicators.saving) {
      this.indicators.saving = true;
      this.workdayUserProvisioningService
        .deleteSelection(selectionId)
        .then(() => {
          this.updateSelections();
        })
        .catch((error) => {
          this.indicators.saving = false;
          this.uiErrorHandlingService.handleModal(error);
        });
    }
  }

  private unApproveMappingAndRemoveUnfinishedMappingId(): void {
    this.$q
      .all([this.workdayUserProvisioningService.changeMappingStatus(false), this.workdayUserProvisioningService.updateWorkdaySettings({ unfinishedSetupMappingId: "" })])
      .catch((error) => {
        this.uiErrorHandlingService.handleModal(error);
      })
      .finally(() => {
        this.indicators.saving = false;
      });
  }
}

export const WizardSelectionsComponent: IComponentOptions = {
  controller: WizardSelectionsCtrl,
  templateUrl: require("./selections.jade"),
  bindings: {
    selections: "=",
  },
};
